import React from 'react';
import { Breadcrumb, Card, Col, Layout } from "antd";
import { useParams } from "react-router-dom";
import { useServiceContext, useSetContext, useUserContext, useContext } from '../../components/Context';
import { useAuth } from '../../components/Auth';
import CollectionServer from '../../components/CollectionServer';
import { useSelector } from 'react-redux';
import { Content } from 'antd/lib/layout/layout';
import { getObjectDisplay } from '../../components/Tool';
var _ = require('lodash');

export default function EnumsPage(props) {
    let { name } = useParams();
    const auth = useAuth();
    const user = useUserContext();
    const context = useContext();
    const setContext = useSetContext();
    const service = useServiceContext();

    const meta = useSelector(state => state.meta);

    const filtersFromMeta = React.useCallback(() => {
        let prop = [];
        let p = _.get(meta[name.toLowerCase()], "properties");
        if(p){
            prop = p.filter(e => _.get(e, "relation.type") !== "one-many").map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range")?["min", "max"]:undefined }))
        }
        return prop;
    }, [meta, name]);

    return (<>
        <Layout style={{ backgroundColor: "white", paddingTop: "15px" }}>
            <Content>
                {meta && <CollectionServer
                    auth={auth}
                    name={name}
                    // source={"/api/query/resourcelocks"}
                    filters={filtersFromMeta}
                    // filters={() => [
                    //     {
                    //         label:"Идентификатор",
                    //         name: "id",
                    //         sort: true,
                    //     }
                    // ]}
                    columns={({ auth, collection, setCollection, request }) => [
                        // {
                        //     key: "0",
                        //     title: "ID",
                        //     render: (text, record, index) => {
                        //         return (record.ID);
                        //     }
                        // },
                        {
                            key: "1",
                            title: "Описание",
                            render: (text, record, index) => {
                                return (getObjectDisplay(record, name, meta));
                            }
                        }
                    ]}
                    // mode={"list"}
                    // render={(item, idx, { setCollection, setCollectionItem, removeCollectionItem, update }) => (<></>)}

                    size={"small"}
                    // titleFunc={(title) => "Заказы"}
                    defaultModelActions={true}
                    defaultCollectionActions={true}
                />}
            </Content>
        </Layout>
    </>);
}